<template>
  <div v-show="isLoaded" class="mNormative_container" v-observe-visibility="startAnimate">
    <img class="mNormative_img" :src="banner_normative" alt="Banner reglamento">
    <img class="mNormative_img-mobile" :src="banner_normative_mobile" alt="Banner reglamento">
    <h1 class="mNormative_title" :class="{animate: animate}">Reglamento</h1>
    <div class="mNormative_row" :class="{animate: animate}">
        <h3 class="mNormative_subtitle"><u>Convocatoria</u></h3>
        <h4 class="mNormative_paragraph">La convocatoria será publicada 20 días antes del torneo <br> <br>
            Todos los jugadores y parejas deberán de estar <br>
            pendientes de las fechas de inscripción e inscribirse en <br>
            tiempo y forma según las convocatorias para asegurar su <br>
            participación. <br> <br>
            Los draws serán publicados 3 días antes de la fecha de <br>
            inicio.</h4>
        <h3 class="mNormative_subtitle two"><u>Lineamiento de participación</u></h3>
        <h4 class="mNormative_paragraph">En caso que un jugador esté en una categoría que no <br>
            corresponda a la suya la MPT podrá dar de baja a la <br>
            pareja para un buen funcionamiento de la categoría. <br> <br>
            Cualquier jugador que quede ascendido de categoría <br> 
            pasara con la mitad de los puntos que allá obtenido. <br> <br>
            Los jugadores solo podrán inscribirse en una categoría
        </h4>
        <h3 class="mNormative_subtitle two"><u>Registro</u></h3>
        <h4 class="mNormative_paragraph">Para poder participar en cualquier torneo oficial de MPT <br>
            es obligatorio contar con su carnet de jugador <br> <br>
            El registro tiene validez por un año calendario (Enero a  <br>
            Diciembre) y es obligatorio para la participación de los <br>
            torneos
        </h4>
        <h3 class="mNormative_subtitle two"><u>Beneficios del jugador</u></h3>
        <h5 class="mNormative_subtitle_p">Carnet</h5>
        <h4 class="mNormative_paragraph">Carnet impreso con protección y cinta. <br> <br>
            Categorizacíon correspondiente del nivel de juego. <br> <br>
            Base de datos con la información de todos los jugadores <br>
            para una buena organización en cada categoría. <br> <br>
            Ranking oficial de MPT <br> <br>
            Acceso a todos los torneos del año <br> <br>
            Abono válido por todo el año
        </h4>
        <h5 class="mNormative_subtitle_p">Inscripción</h5>
        <h4 class="mNormative_paragraph">Costo de la cancha ya incluido. <br> <br>
            Un partido asegurado <br> <br>
            Bolas nueva en cada partido <br> <br>
            Trofeos más premios para los finalistas <br> <br>
            Rifa para todos los jugadores <br> <br>
            Comida y evento incluido el día de la final
        </h4>
        <h3 class="mNormative_subtitle two"><u>Horarios</u></h3>
        <h4 class="mNormative_paragraph">Para ser un cambio de horario los 4 jugadores implicados <br>
            deben estar de acuerdo de la modificación, siempre y <br>
            cuando el juez de mesa de control lo autorice <br> <br>
            El partido se podrá jugar en otra sede alterna siempre y <br>
            cuando los 4 jugadores estén de acuerdo y el comité de <br>
            organización lo apruebe <br> <br>
            Pasados los 15 minutos exactos del horario del partido se <br>
            aplicará default. (Sin excepciones)
        </h4>
        <h3 class="mNormative_subtitle two"><u>Punto de discusión</u></h3>
        <h4 class="mNormative_paragraph">Al no haber árbitro central en cada juego o en cada <br>
            cancha, los jugadores serán responsables de sus propios <br> 
            partidos, cuando un punto está en duda se repitiera el <br> 
            punto con dos saques, esto para fomentar un juego <br> limpio. <br> <br>
            En caso de presentar este problema en más de dos <br>
            ocasiones en el mismo partido los jugadores podrán pedir <br>
            un árbitro en mesa de control y los jugadores se obligan a <br> 
            respetar las decisiones del arbitro central.
        </h4>
        <!-- inicio tiempos de pausa -->
        <h3 class="mNormative_subtitle two"><u>Tiempos de pausa</u></h3>
        <div class="mNormative_Time_Col">
            <div class="mNormative_Time_Row">
                <div class="mNormative_Time_Circle">
                    <span class="mNormative_Time_Number">5</span>
                    <span class="mNormative_Time_Text">min</span>
                </div>
                <div class="mNormative_Time_Description">
                    <span>Calentamiento</span>
                </div>
            </div>

            <div class="mNormative_Time_Row">
                <div class="mNormative_Time_Circle">
                    <span class="mNormative_Time_Number">20</span>
                    <span class="mNormative_Time_Text">seg</span>
                </div>
                <div class="mNormative_Time_Description">
                    <span>Entre punto y punto</span>
                </div>
            </div>

            <div class="mNormative_Time_Row">
                <div class="mNormative_Time_Circle">
                    <span class="mNormative_Time_Number">20</span>
                    <span class="mNormative_Time_Text">seg</span>
                </div>
                <div class="mNormative_Time_Description">
                    <span>Cambio de lado 1-0 y TB</span>
                </div>
            </div>

            <div class="mNormative_Time_Row">
                <div class="mNormative_Time_Circle">
                    <span class="mNormative_Time_Number">90</span>
                    <span class="mNormative_Time_Text">seg</span>
                </div>
                <div class="mNormative_Time_Description">
                    <span>Cambio de lado impares</span>
                </div>
            </div>

            <div class="mNormative_Time_Row">
                <div class="mNormative_Time_Circle">
                    <span class="mNormative_Time_Number">20</span>
                    <span class="mNormative_Time_Text">seg</span>
                </div>
                <div class="mNormative_Time_Description">
                    <span>Cambio de lado 1-0 y TB</span>
                </div>
            </div>

            <div class="mNormative_Time_Row">
                <div class="mNormative_Time_Circle">
                    <span class="mNormative_Time_Number">120</span>
                    <span class="mNormative_Time_Text">seg</span>
                </div>
                <div class="mNormative_Time_Description">
                    <span>Final del set</span>
                </div>
            </div>

            <div class="mNormative_Time_Row">
                <div class="mNormative_Time_Circle">
                    <span class="mNormative_Time_Number">1-15</span>
                    <span class="mNormative_Time_Text">seg</span>
                </div>
                <div class="mNormative_Time_Description">
                    <span>Atención médica</span>
                </div>
            </div>
        </div>
        <!-- fin tiempos de pausa -->
        <h3 class="mNormative_subtitle two"><u>Conducta</u></h3>
        <h4 class="mNormative_paragraph">Respetar a todos los jugadores, espectadores,<br>
            organizadores del torneo y socios de los clubes, y guardar<br> 
            un comportamiento adecuado dentro y fuera de las<br> 
            canchas e instalaciones de los clubes sedes.<br> <br>
            Respetar cualquier decisión tomada por el árbitro del <br>
            torneo que tenga bases en el presente reglamento. <br> <br>
            Queda terminalmente prohibido que algún jugador haga<br>
            uso excesivo de la fuerza para provocar o lastimar a su<br>
            adversario, si se da el caso es obligación del árbitro <br>
            principal amonestar al jugador con una llamada de <br>
            atención. Si la situación continua el jugador será <br>
            expulsado del torneo sin replica alguna.
        </h4>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Bowser from "bowser"; 
import banner_normative from '@/assets/home/normative.png'
import banner_normative_mobile from '@/assets/home/normative_mobile.png'
export default {
    name: "Normative",
    data() {
        return {
            animate: false,
            isSafari: false,
            banner_normative,
            banner_normative_mobile
        };
    },
    computed: {
        ...mapGetters(["isLoaded"]),
    },
    methods: {
        startAnimate(isVisible) {
            if(isVisible) {
                this.animate=true;
            }
        },
    },
    mounted() {
        window.scrollTo(0,0)
    },
    beforeMount() {
        const browser = Bowser.getParser(window.navigator.userAgent);
        if (browser.getBrowserName()=='Safari') {
            this.isSafari = true
        }
    },
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/Normative.scss";
</style>